export const SET_USER_DATA = 'SET_USER_DATA';
export const RESET_USER_PHOTO = 'RESET_USER_PHOTO';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const READ_NOTIFICATIONS = 'READ_NOTIFICATIONS';
